<template>
    <div class="locked-container">
        <div class="locked-card">
            <div class="logo-container">
                <img :src="logoUrl" alt="Logo" class="logo" />
            </div>
            <h2>Zárt körű hozzáférés</h2>
            <p>Az oldal megtekintéséhez kérjük, adja meg a hozzáférési kódját.</p>
            
            <b-form @submit.prevent="submitCode">
                <b-form-group>
                    <b-form-input
                        v-model="code"
                        type="password"
                        placeholder="Hozzáférési kód"
                        required
                        class="text-center"
                    ></b-form-input>
                </b-form-group>
                
                <b-button type="submit" variant="primary" block :disabled="loading">
                    <span v-if="loading">Ellenőrzés...</span>
                    <span v-else>Belépés</span>
                </b-button>
            </b-form>
        </div>
    </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
    name: "LockedScreen",
    data() {
        return {
            code: "",
            loading: false
        };
    },
    computed: {
        logoUrl() {
            if (process.env.VUE_APP_APP_WEBSITE === 'magic_singles') {
                return 'https://magic-singles.hu/mtg-logo.png';
            } else if (process.env.VUE_APP_APP_WEBSITE === 'ex_magic_singles') {
                return 'https://ex.magic-singles.hu/mtg-logo.png';
            } else if (process.env.VUE_APP_APP_WEBSITE === 'riftbound_singles') {
                return 'https://riftbound-singles.hu/riftbound-logo.png';
            }
            return 'https://magic-singles.hu/mtg-logo.png';
        }
    },
    methods: {
        submitCode() {
            if (!this.code) return;
            
            this.loading = true;
            ApiService.post('/system/unlock', { code: this.code })
                .then(response => {
                    this.loading = false;
                    if (response.data.status === 'success') {
                        // Mentés localStorage-ba, lejárattal (1 nap = 24 * 60 * 60 * 1000 ms)
                        const expiry = new Date().getTime() + (24 * 60 * 60 * 1000);
                        const tokenData = {
                            code: response.data.code,
                            expiry: expiry
                        };
                        localStorage.setItem('site_access_token', JSON.stringify(tokenData));
                        
                        // Átirányítás a főoldalra
                        window.location.href = '/';
                    }
                })
                .catch(() => {
                    this.loading = false;
                    alert("Érvénytelen hozzáférési kód!");
                });
        }
    }
};
</script>

<style scoped>
.locked-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.locked-card {
    background: white;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    max-width: 400px;
    width: 100%;
    text-align: center;
}

.logo-container {
    margin-bottom: 20px;
}

.logo {
    max-width: 150px;
    max-height: 150px;
    object-fit: contain;
}

h2 {
    margin-bottom: 15px;
    color: #333;
}

p {
    margin-bottom: 25px;
    color: #666;
}
</style>
